export function onlyUnique(value: any, index: number, self: any[]): boolean {
    return self.indexOf(value) === index;
}
